module.exports = __webpack_public_path__ + "shared/static_img/attachment.05eb5b1a.svg";